/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useRef } from "react";
import {
  GoogleMap,
  Marker,
  Autocomplete,
  useJsApiLoader,
} from "@react-google-maps/api";

const containerStyle = { width: "100%", height: "360px" };
// fallback

interface PropsType {
  setDetails?: any;
  details?: {
    lat: number;
    lng: number;
    placeId?: string;
    formattedAddress?: string;
    addressComponents?: google.maps.GeocoderAddressComponent[];
  };
  defaultCenter: {
    lat: number;
    lng: number;
  };
  hideSearch?: boolean;
}

export default function PlacePicker(props: PropsType) {
  const { setDetails, defaultCenter, hideSearch } = props;
  const GOOGLE_MAPS_API_KEY = "AIzaSyDcQQw5LJ5YLntPe4kzR_8w-TKGumSFmfI";
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: ["places"],
  });

  const [position, setPosition] = useState(defaultCenter);

  const acRef = useRef<google.maps.places.Autocomplete | null>(null);

  const onPlaceChanged = () => {
    if (!acRef.current) return;
    const place = acRef.current.getPlace();
    const loc = place.geometry?.location;
    if (!loc) return;

    const lat = loc.lat();
    const lng = loc.lng();
    setPosition({ lat, lng });
    setDetails({
      lat,
      lng,
      placeId: place.place_id,
      formattedAddress: place.formatted_address,
      addressComponents: place.address_components,
    });
  };

  const onMarkerDragEnd = async (e: google.maps.MapMouseEvent) => {
    const lat = e.latLng?.lat() ?? position.lat;
    const lng = e.latLng?.lng() ?? position.lng;
    setPosition({ lat, lng });

    // reverse geocode to get human-readable address
    const geocoder = new google.maps.Geocoder();
    const res = await geocoder.geocode({ location: { lat, lng } });
    const best = res.results[0];
    setDetails({
      lat,
      lng,
      placeId: best?.place_id,
      formattedAddress: best?.formatted_address,
      addressComponents: best?.address_components,
    });
  };

  if (!isLoaded) return null;

  return (
    <div style={{ width: "100%" }}>
      {!hideSearch && (
        <Autocomplete
          onLoad={(ac) => (acRef.current = ac)}
          onPlaceChanged={onPlaceChanged}
        >
          <input
            placeholder="Search a place"
            style={{
              width: "100%",
              padding: 8,
              border: "1px solid #ccc",
              borderRadius: 6,
            }}
          />
        </Autocomplete>
      )}

      <GoogleMap mapContainerStyle={containerStyle} center={position} zoom={14}>
        <Marker
          position={position}
          draggable={!hideSearch}
          onDragEnd={onMarkerDragEnd}
        />
      </GoogleMap>

      {/* What you can send to your API */}
      {/* <pre
        style={{
          margin: 0,
          background: "#f7f7f7",
          padding: 8,
          borderRadius: 6,
        }}
      >
        {JSON.stringify(details, null, 2)}
      </pre> */}
    </div>
  );
}
